module.exports = __webpack_public_path__ + "img/icon-account-circle-active.2b5dac68.svg";